// Content for the Google & Meta Ads (Paid Media) section on the pricing page.

export const PM_ECOSYSTEM = ['Website', 'SEO / GEO', 'Paid Media', 'Ongoing Growth'];

export const PM_SUMMARY = [
  { name: 'Website Design', price: 'From £1,750 + VAT' },
  { name: 'SEO + GEO Growth', price: 'From £595 + VAT / mo' },
  { name: 'Google or Meta Ads', price: 'From £495 + VAT / mo' },
  { name: 'Google + Meta Ads', price: 'From £795 + VAT / mo' },
];

export const PM_CARDS = [
  {
    id: 'google-ads',
    title: 'Google Ads Management',
    priceEx: 'From £495 + VAT',
    period: 'per month',
    priceInc: '£594 including VAT',
    onboarding: 'One-off onboarding from £395 + VAT.',
    description:
      'Reach customers actively searching for the products and services your business offers. Campaigns may include Google Search, Performance Max, Shopping, remarketing and other appropriate Google Ads formats.',
    includes: [
      'Account and campaign strategy',
      'Existing account audit where applicable',
      'Keyword and search-intent research',
      'Competitor analysis',
      'Campaign architecture',
      'Search adverts',
      'Performance Max where appropriate',
      'Google Shopping where appropriate',
      'Remarketing',
      'Negative-keyword management',
      'Audience optimisation',
      'Bid and budget management',
      'Conversion tracking',
      'Google Analytics integration',
      'Merchant Centre / feed review where applicable',
      'Advert testing',
      'Landing-page recommendations',
      'Continuous performance monitoring',
      'Monthly reporting',
      'Ongoing strategic optimisation',
    ],
    cta: 'Discuss Google Ads',
    event: 'google_ads_cta_click',
    projectType: 'Google Ads Management',
  },
  {
    id: 'meta-ads',
    title: 'Meta Ads Management',
    priceEx: 'From £495 + VAT',
    period: 'per month',
    priceInc: '£594 including VAT',
    onboarding: 'One-off onboarding from £395 + VAT.',
    description:
      'Reach, engage and retarget prospective customers across Facebook and Instagram using strategically structured paid-social campaigns.',
    includes: [
      'Meta advertising strategy',
      'Account review and campaign setup',
      'Facebook advertising',
      'Instagram advertising',
      'Audience research',
      'Prospecting campaigns',
      'Retargeting campaigns',
      'Campaign architecture',
      'Budget allocation',
      'Advert copy',
      'Creative-testing strategy',
      'Audience testing',
      'Placement optimisation',
      'Meta Pixel and standard conversion tracking',
      'Continuous performance monitoring',
      'Monthly reporting',
      'Ongoing strategic optimisation',
    ],
    note:
      'Standard advert copy, creative direction and reasonable adaptations of supplied campaign assets are included. Bespoke graphic design, photography, UGC and video-production requirements may be quoted separately.',
    cta: 'Discuss Meta Ads',
    event: 'meta_ads_cta_click',
    projectType: 'Meta Ads Management',
  },
  {
    id: 'google-meta',
    title: 'Google + Meta Growth',
    recommended: true,
    priceEx: 'From £795 + VAT',
    period: 'per month',
    priceInc: '£954 including VAT',
    onboarding: 'One-off onboarding from £595 + VAT.',
    description:
      "Combine high-intent Google traffic with Meta's powerful audience, discovery and retargeting capabilities. An integrated paid-media programme lets Boost! capture existing demand while creating new demand and bringing previous visitors back into the buying journey.",
    includesHeading: 'Everything in Google and Meta Ads Management, plus:',
    includes: [
      'Cross-channel strategy',
      'Coordinated campaign planning',
      'Combined budget recommendations',
      'Cross-platform performance analysis',
      'Integrated remarketing strategy',
      'Customer-journey analysis',
      'Unified monthly reporting',
      'Cross-channel optimisation recommendations',
    ],
    cta: 'Build my paid-media strategy',
    event: 'combined_paid_media_cta_click',
    projectType: 'Google + Meta Ads Management',
  },
];

export const PM_FEE_ROWS = [
  { spend: 'Up to £2,500', single: '£495 + VAT', singleInc: '£594 inc', dual: '£795 + VAT', dualInc: '£954 inc' },
  { spend: '£2,501 – £5,000', single: '£695 + VAT', singleInc: '£834 inc', dual: '£995 + VAT', dualInc: '£1,194 inc' },
  { spend: '£5,001 – £10,000', single: '£995 + VAT', singleInc: '£1,194 inc', dual: '£1,395 + VAT', dualInc: '£1,674 inc' },
  { spend: 'Over £10,000', single: 'From £1,250 + VAT', singleInc: '£1,500 inc', dual: 'From £1,650 + VAT', dualInc: '£1,980 inc' },
];

export const PM_ONBOARDING = [
  {
    id: 'single',
    title: 'Single Platform Onboarding',
    scope: 'Google OR Meta',
    priceEx: 'From £395 + VAT',
    priceInc: '£474 including VAT',
    launch: 'Typical setup and launch: 5–7 working days',
  },
  {
    id: 'dual',
    title: 'Dual Platform Onboarding',
    scope: 'Google + Meta',
    priceEx: 'From £595 + VAT',
    priceInc: '£714 including VAT',
    launch: 'Typical setup and launch: 7–10 working days',
  },
];

export const PM_ONBOARDING_INCLUDES = [
  'Business and commercial discovery',
  'Existing account audit',
  'Competitor analysis',
  'Account structure',
  'Campaign strategy',
  'Conversion definition',
  'Analytics review',
  'Tracking configuration',
  'Audience or keyword research',
  'Initial advert creation',
  'Budget recommendations',
  'Initial campaign build',
  'Testing before launch',
];

export const PM_AI_ANALYSIS = [
  'Continuous campaign monitoring',
  'Performance trend analysis',
  'Budget anomalies',
  'Search and audience opportunities',
  'Conversion trends',
  'Cross-channel comparison',
  'Faster reporting and insight',
];

export const PM_HUMAN_STRATEGY = [
  'Commercial judgement',
  'Campaign direction',
  'Budget decisions',
  'Creative strategy',
  'Audience and keyword decisions',
  'Landing-page recommendations',
  'Client communication',
  'Strategic optimisation',
];

export const PM_CREATIVE_INCLUDES = [
  'Static Meta adverts',
  'Google Display assets',
  'Campaign graphics',
  'Offer-led creative',
  'Image resizing',
  'Format adaptation',
  'Creative variations',
  'Advertising copy',
];

export const PM_REPORTING = [
  'Advertising spend',
  'Revenue',
  'Return on advertising spend',
  'Leads',
  'Cost per lead',
  'Purchases',
  'Cost per acquisition',
  'Conversion rate',
  'Click-through rate',
  'Search terms',
  'Audience performance',
  'Campaign trends',
  'Recommendations and next actions',
];

export const PM_EXPECTATION_FACTORS = [
  'Available advertising budget',
  'Market competitiveness',
  'Product or service demand',
  'Website conversion performance',
  'Offer strength',
  'Pricing',
  'Geographic targeting',
  'Existing brand recognition',
  'Tracking accuracy',
  'Creative quality',
  'Seasonality',
];

export const PM_PROCESS = [
  { step: '1', title: 'Discover', copy: 'Understand the business, offer, audience and commercial objectives.' },
  { step: '2', title: 'Measure', copy: 'Confirm conversions, analytics and the data required to evaluate performance.' },
  { step: '3', title: 'Build', copy: 'Create campaigns, targeting, adverts and initial budget structures.' },
  { step: '4', title: 'Launch', copy: 'Complete testing and activate the campaigns.' },
  { step: '5', title: 'Optimise', copy: 'Continuously analyse performance and improve targeting, bidding, budgets and creative.' },
  { step: '6', title: 'Grow', copy: 'Use accumulated campaign data to identify opportunities to scale successful activity.' },
];

export const PAID_MEDIA_FAQS = [
  {
    q: 'How much does Google Ads management cost?',
    a: 'Boost! Google Ads management begins at £495 + VAT per month for advertising budgets up to £2,500. Larger accounts are priced according to advertising spend and campaign complexity.',
  },
  {
    q: 'How much does Meta Ads management cost?',
    a: 'Boost! Facebook and Instagram Ads management begins at £495 + VAT per month. Advertising spend is separate.',
  },
  {
    q: 'Can Boost! manage Google and Meta together?',
    a: 'Yes. Combined Google and Meta management starts at £795 + VAT per month and provides an integrated cross-channel advertising strategy.',
  },
  {
    q: 'Is advertising spend included in the management fee?',
    a: 'No. Advertising spend is separate and paid directly by the client to Google, Meta or the relevant advertising platform.',
  },
  {
    q: 'What advertising budget do I need?',
    a: 'The appropriate budget depends on the market, geographic area, campaign objectives and likely cost of reaching suitable customers. Boost! will recommend a sensible starting budget before campaigns launch. For many small-business campaigns, a monthly advertising budget of at least approximately £750–£1,000 provides a more useful testing base, although this varies considerably by industry.',
  },
  {
    q: 'Who owns my advertising accounts?',
    a: 'Wherever practical, the client does. Boost! prefers to operate within client-owned advertising accounts so clients retain their campaign history and data.',
  },
  {
    q: 'Can you guarantee results?',
    a: 'No responsible advertising provider can guarantee a specific ROAS, cost per lead, sales volume or other commercial result. Boost!\u2019s role is to continually analyse, test and optimise activity to improve the efficiency and commercial performance of the campaigns.',
  },
  {
    q: 'Do you create the advertising graphics?',
    a: 'Ad copy, creative direction and reasonable adaptations of existing assets can form part of campaign management. More substantial graphic design, photography, UGC or video requirements are available as additional services.',
  },
  {
    q: 'How quickly can campaigns launch?',
    a: 'A standard single-platform campaign will usually be ready within approximately 5–7 working days once all required access, information and assets have been supplied. Combined Google and Meta programmes typically require approximately 7–10 working days.',
  },
  {
    q: 'Is there a minimum commitment?',
    a: 'Boost! normally recommends an initial three-month management period to allow campaigns sufficient time to generate data, test opportunities and optimise performance.',
  },
];

export const AD_BUDGET_OPTIONS = [
  'Under £500',
  '£500–£1,000',
  '£1,000–£2,500',
  '£2,500–£5,000',
  '£5,000–£10,000',
  '£10,000+',
  'Not sure yet',
];

export const AD_STATUS_OPTIONS = [
  'Not currently advertising',
  'Currently running Google Ads',
  'Currently running Meta Ads',
  'Currently running Google + Meta',
  'Using another agency',
  'Managing campaigns internally',
];

export const PAID_MEDIA_PROJECT_TYPES = [
  'Google Ads Management',
  'Meta Ads Management',
  'Google + Meta Ads Management',
  'Paid Media Creative',
  'Website + Paid Media',
  'SEO/GEO + Paid Media',
  'Complete Growth Programme',
  'Existing advertising account audit',
];
